module.exports = __webpack_public_path__ + "static/media/driving-force.30e1dc14.png";